export const COLOR_PALLETTE = ['#9e272f', 'lightgrey', '#296b8e'] as [
  string,
  string,
  string
]
export const COLOR_PALLETTE_DARK_MODE = ['#e93a45', 'lightgrey', '#3385b1'] as [
  string,
  string,
  string
]

export const AGE_THRESHOLD = 50